/*
eslint class-methods-use-this: ["error", {
  "exceptMethods": [
    processData
  ]
}]
*/

const { WalletReason } = require('pando-constants');
const ArrivalBreach = require('./implementations/wallet/arrival-breach-charges');
const AcceptanceBreach = require('./implementations/wallet/acceptance-breach-charges');

class Wallet {
  processData(type, data, prevTransporterId = null) {
    let walletAmount = 0;
    switch (type) {
      case WalletReason.SLA_BREACH_RE_ASSIGNED: {
        const arrivalBreach = new ArrivalBreach();
        walletAmount = arrivalBreach.calculateWalletCharge(data, prevTransporterId);
        break;
      }
      case WalletReason.ACCEPTANCE_SLA_BREACH_RE_ASSIGNED: {
        const acceptanceBreach = new AcceptanceBreach();
        walletAmount = acceptanceBreach.calculateWalletCharge(data, prevTransporterId);
        break;
      }
      default:
        logger.error(`unhandled wallet type. ${type}`);
        break;
    }
    return walletAmount;
  }
}

module.exports = Wallet;
